exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row[data-v-869bc93e]{margin:15px 0}.col-xs-6[data-v-869bc93e]{height:100px;border:1px solid #efefef;border-radius:2px}.col-left[data-v-869bc93e]{background-color:#fff}.col-inner[data-v-869bc93e],.col-right[data-v-869bc93e]{background-color:#efefef}.col-inner[data-v-869bc93e]{height:15px;margin-top:15px;border-radius:4px}", ""]);

// exports
